import { Alert, Box, CircularProgress } from '@mui/material';
import type { ReactNode } from 'react';
import React from 'react';

import { hasAnyPermission } from '@/api/admin-access';
import { UserStore } from '@/stores';

interface PermissionRouteProps {
  children: ReactNode;
  permissionKey: string | string[];
}

const PermissionRoute: React.FC<PermissionRouteProps> = ({
  children,
  permissionKey,
}) => {
  const access = UserStore.useState((state) => state.access);
  const loading = UserStore.useState((state) => state.loadingAccess);
  const accessError = UserStore.useState((state) => state.accessError);

  if (loading) {
    return (
      <Box py={8} textAlign="center">
        <CircularProgress size={28} />
      </Box>
    );
  }

  const permissionKeys = Array.isArray(permissionKey)
    ? permissionKey
    : [permissionKey];
  if (!hasAnyPermission(access, permissionKeys, 'read')) {
    return (
      <Alert severity="error" sx={{ maxWidth: 800, margin: '30px auto' }}>
        {accessError || 'You do not have permission to view this page.'}
      </Alert>
    );
  }

  return <>{children}</>;
};

export default PermissionRoute;
